module.exports = __webpack_public_path__ + "img/DinosaurLandWorld.7d689a3e.jpg";